import { createContext, useContext } from "react";

export const CalendarContext = createContext(null);

export const useCalendar = () => useContext(CalendarContext);
